import Button from "../../staff/Button";
import DropDownMultiple from "../../staff/DropDownMultiple";
import CloseModal from "../../Atomos/Icons/EditMode/CloseModal";
import { usePersonForm } from "./personForm/PersonFormContext";
import InputTextArea from "../../staff/InputTextArea";
import { ILanguage } from "../../../interfaces";
import { useMemo, useState } from "react";
import AddLanguageForm from "../../../pages/Catalogs/CRUD/AddLanguageForm";
import Modal from "../../Atomos/Modals/Modal";
import { useStaffMode } from "../../../hooks/StaffModeProvider";

interface LanguageProps {
  languages: ILanguage[];
  onLanguageCreated?: (language: ILanguage) => void;
}
const Languages: React.FC<LanguageProps> = ({
  languages,
  onLanguageCreated,
}) => {
  const { form, setField, touchField } = usePersonForm();
  const { isStaffMode } = useStaffMode();
  const [addLanguageModalOpen, setAddLanguageModalOpen] = useState(false);

  const handleAddLanguage = (value: any) => {
    setField(
      "languages",
      value.map((language: any) => language.name),
    );
    touchField("languages");
  };

  const handleRemoveLanguage = (language: string) => {
    setField(
      "languages",
      form.languages?.filter((l: string) => l !== language),
    );
    touchField("languages");
  };

  const selectedLanguages = useMemo(() => {
    return languages
      .filter((language) => form.languages?.includes(language.name))
      .map((language) => ({ id: language.id ?? "", name: language.name }));
  }, [form.languages, languages]);

  const handleNewLanguageSaved = (lang: ILanguage) => {
    onLanguageCreated?.(lang);
    const current = form.languages ?? [];
    if (!current.includes(lang.name)) {
      setField("languages", [...current, lang.name]);
      touchField("languages");
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col md:flex-row gap-2">
            <div className="flex-1">
              <DropDownMultiple
                title="Languages"
                options={languages.map((language) => ({
                  id: language.id ?? "",
                  name: language.name,
                }))}
                value={selectedLanguages}
                onChange={(value) => {
                  handleAddLanguage(value);
                }}
                multiple
              />
            </div>
            <div className="flex items-end">
              <Button
                text="Add language(s)"
                onClick={() => setAddLanguageModalOpen(true)}
                color={isStaffMode ? "secondary" : "primary"}
                variant="filled"
                size="fixed"
              />
            </div>
          </div>
          <div className="flex gap-2">
            {form.languages?.map((language: string) => (
              <div
                key={language}
                className="flex px-2 py-1 rounded-md bg-gray-100 items-center gap-2 text-xs"
              >
                <label>{language}</label>
                <button
                  onClick={() => {
                    handleRemoveLanguage(language);
                  }}
                  className="w-4 h-4 flex items-center justify-center"
                >
                  <CloseModal />
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <InputTextArea
            title="Bar Admissions"
            placeholder="ex: Bar Admission, Notes"
            value={form.barAdmissions ?? ""}
            onChange={(v) => setField("barAdmissions", v)}
            onBlur={() => touchField("barAdmissions")}
            maxChars={1500}
            showCharacterCount
          />
        </div>
      </div>
      <Modal
        isModalOpen={addLanguageModalOpen}
        toggleModal={() => setAddLanguageModalOpen(false)}
        title="New language"
        compact
        className="max-w-lg"
      >
        <AddLanguageForm
          isActive={addLanguageModalOpen}
          onLanguageCreated={handleNewLanguageSaved}
          onCancel={() => setAddLanguageModalOpen(false)}
        />
      </Modal>
    </>
  );
};

export default Languages;
